import React from 'react'
import styled from '@emotion/styled'

const RotatingImg = styled.img`
  label: RotatingImg;
  animation: rotation 2s infinite linear;
`

const Loader = () => (
  <RotatingImg src='./../../images/loader.gif' alt="loading..." />
)

export default Loader
